import { Box } from '@mui/material';

import Icon from '@/contents/General/Icon';
import { Board } from '@/contents/General/Panels';
import Stack from '@/contents/General/Stack';
import Typography from '@/contents/General/Typography';
import type { PublicUser, User } from '@/types/domain';

import CampHistory from './CampHistory';

const UserContents = ({ user }: { user: PublicUser | User }) => {
  return (
    <>
      <Box paddingBottom={4}>
        <CampHistory
          totalCampingDaysNum={
            (user.total_review_num ?? 0) + (user.camping_days ?? 0)
          }
          startHistory={new Date(user.start_history ?? new Date())}
        />
      </Box>
      <Stack column space={2} paddingBottom={4}>
        <Typography fontSize={16} fontWeight={700} variant="h2">
          自己紹介
        </Typography>
        <Board no_border="true">
          <Typography fontSize={15} whiteSpace="pre-wrap">
            {user.self_introduction ? user.self_introduction : '-'}
          </Typography>
        </Board>
      </Stack>
      <Stack column space={2} paddingBottom={4}>
        <Typography fontSize={16} fontWeight={700} variant="h2">
          お気に入りのギア
        </Typography>
        <Board no_border="true">
          <Typography fontSize={15}>
            {user.liked_gear ? user.liked_gear : '-'}
          </Typography>
        </Board>
      </Stack>
      <Stack column space={2} paddingBottom={4}>
        <Typography fontSize={16} fontWeight={700} variant="h2">
          リンク
        </Typography>
        <Board no_border="true">
          {user.url && user.url_title ? (
            <Stack alignCenter>
              <Icon iconType="arrow-right" color="primary" />
              <a href={user.url} target="_blank" rel="noreferrer">
                <Typography fontSize={14} color="primary" fontWeight={700}>
                  {user.url_title}
                </Typography>
              </a>
            </Stack>
          ) : (
            <Box height={'25px'}></Box>
          )}
        </Board>
      </Stack>
    </>
  );
};
export default UserContents;
